import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

function Score({ label, value, onChange, testid }) {
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <div className="flex gap-1 mt-2" data-testid={testid}>
        {[0,1,2,3,4,5,6,7,8,9,10].map((n) => (
          <button key={n} onClick={() => onChange(n)} className={`flex-1 h-10 border rounded-md text-sm font-semibold transition-all ${value === n ? "bg-[#C07C88] text-white border-[#C07C88]" : "border-border hover:bg-[#FAFAFA]"}`}>{n}</button>
        ))}
      </div>
    </div>
  );
}

export default function PublicEventNPS() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", speaker_score: null, content_score: null, infra_score: null, overall_score: null, comment: "" });
  const [sent, setSent] = useState(false);

  useEffect(() => { api.get(`/public/event-nps/${token}`).then((r) => setData(r.data)); }, [token]);

  const submit = async () => {
    for (const k of ["speaker_score","content_score","infra_score","overall_score"]) {
      if (form[k] === null) return toast.error("Preencha todas as notas");
    }
    try {
      await api.post(`/public/event-nps/${token}`, form);
      setSent(true);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  if (!data) return <div className="min-h-screen flex items-center justify-center overline">Carregando…</div>;
  const brand = data.brand || {};
  const primary = brand.brand_primary || "#C07C88";
  const gold = brand.brand_accent || "#D4AF37";

  if (sent) return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <Card className="p-10 max-w-md w-full text-center border-border shadow-none">
        <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: `${gold}15` }}><CheckCircle2 size={36} style={{ color: gold }} /></div>
        <p className="font-heading text-2xl mt-4" style={{ color: primary }}>Obrigado!</p>
        <p className="text-sm text-muted-foreground mt-2">Sua avaliação foi registrada e ajudará a melhorar nossos próximos eventos.</p>
      </Card>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#FAFAFA] py-8 px-4">
      <div className="max-w-2xl mx-auto doc-paper p-8 md:p-10">
        <p className="overline">Pesquisa de Satisfação</p>
        <h1 className="font-heading text-3xl mt-2" style={{ color: primary }}>{data.event.title}</h1>
        <p className="text-sm text-muted-foreground mt-2">Sua opinião é essencial. Leva menos de 2 minutos.</p>
        <div className="mt-8 space-y-6">
          <div className="grid md:grid-cols-2 gap-3">
            <div><Label className="text-xs">Nome (opcional)</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="nps-name" /></div>
            <div><Label className="text-xs">E-mail (opcional)</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          </div>
          <Score label="Palestrante(s)" value={form.speaker_score} onChange={(n) => setForm({ ...form, speaker_score: n })} testid="score-speaker" />
          <Score label="Conteúdo" value={form.content_score} onChange={(n) => setForm({ ...form, content_score: n })} testid="score-content" />
          <Score label="Infraestrutura" value={form.infra_score} onChange={(n) => setForm({ ...form, infra_score: n })} testid="score-infra" />
          <Score label="Avaliação geral (0 = ruim, 10 = excelente)" value={form.overall_score} onChange={(n) => setForm({ ...form, overall_score: n })} testid="score-overall" />
          <div><Label className="text-xs">Comentário (opcional)</Label><Textarea rows={3} value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} data-testid="nps-comment" /></div>
          <Button className="w-full h-12" style={{ background: primary, color: "#fff" }} onClick={submit} data-testid="nps-submit">Enviar avaliação</Button>
        </div>
      </div>
    </div>
  );
}
